import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles, Typography } from '@material-ui/core';
import { navigate } from '@reach/router';
import theme from '../../theme/theme';
import styles from './styles';

const {
  Icons: {
    general: { Add },
  },
} = theme;

const AddSortBy = ({ classes, t }) => {
  const onHandleClick = () => {
    navigate('sort-by');
  };

  return (
    <React.Fragment>
      <span className={classes.container}>
        <span className={classes.title__container}>
          <Typography className={classes.title}>{t('filter.label.sort-by')}</Typography>
          <Typography className={classes.subtitle__text}>
            {t('filter.label.sort-category')}
          </Typography>
        </span>
        <img src={Add} alt="Add" className={classes.plus__sign} onClick={onHandleClick} />
      </span>
    </React.Fragment>
  );
};

AddSortBy.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(AddSortBy));
